import { computed, SetupContext } from '@vue/composition-api'
import $fetch from '@/api'
import { openMessage } from '@/utils/system.tsx'
import getGoodsCommonData from './goods_data'
import { tbodyScroll } from './goods_utils'

interface Level {
    level1: number | null
    level2?: number | null
}

interface IProps {
    onGoodsGroupChange: () => void
}

export default function(props: IProps, ctx: SetupContext) {
    const {
        isSearch,
        isGoodsListLoading,
        isHasMore,
        isLoading,
        status: oStatus,
        eventTarget,
        page: oPage,
        bindListener,
        initScrollLoad,
        keyword,
        selectedGoods,
        goodsList,
        currentActiveGroup,
        getCurEvent
    } = getGoodsCommonData()

    const isSelectAll = computed({
        get: () => {
            return selectedGoods.value.length === goodsList.value.length && goodsList.value.length > 0
        },
        set: (val) => {
            if (val) {
                selectedGoods.value = goodsList.value.map(value => value.id)
            } else {
                selectedGoods.value = []
            }
        }
    })

    const isIndeterminate = computed(() => {
        if (selectedGoods.value.length === goodsList.value.length && selectedGoods.value.length > 0) {
            return false
        } else if (selectedGoods.value.length > 0) {
            return true
        } else {
            return false
        }
    })

    const currentLevel = {
        level1: 0,
        level2: 0
    }

    function getGoodsByGroup(page = oPage.value, limit = 20, level1: number = currentActiveGroup.level1, level2: number = currentActiveGroup.level2, oKeyword?: string, withLoading?: boolean, status?: number) {
        let curStatus = oStatus.value
        currentLevel.level1 = level1
        if (level2 != null && level2 !== 0) {
            currentLevel.level2 = level2
        } else {
            currentLevel.level2 = 0
        }
        if (oKeyword === '') {
            keyword.value = ''
            isSearch.value = false
        }
        if (oKeyword !== '' && typeof oKeyword === 'string') {
            keyword.value = oKeyword
            isSearch.value = true
        }
        if (status != null) {
            curStatus = status
        }
        withLoading && (isGoodsListLoading.value = true)
        return $fetch.post({
            url: '/goods/getgoods',
            params: {
                page,
                limit,
                status: curStatus,
                group_ids: currentLevel.level1 ? [ currentLevel.level1 ] : undefined,
                secondary_group_id: currentLevel.level2,
                keyword: keyword.value || undefined
            }
        }).then(data => {
            if (isSelectAll.value) {
                // 等goodsList赋值完成，再设置改值
                setTimeout(() => {
                    isSelectAll.value = true
                }, 0)
            }
            if (page === 1) {
                goodsList.value = []
                ctx.root.$nextTick(() => {
                    goodsList.value = data.goods_list
                    initScrollLoad(data)
                })
            } else {
                goodsList.value =  goodsList.value.concat(data.goods_list)
            }
            return data
        }).catch(e => {
            openMessage('error', e.message)
        }).finally(() => {
            withLoading && (isGoodsListLoading.value = false)
        })
    }

    function onGoodsMove(evt: any) {
        console.log(evt)
        if (evt.to.classList.contains('level-2-group')) {
            return false
        }
    }

    function onGoodsDragEnd(goodsInfo: any, evt: any) {
        if (goodsInfo == null || goodsInfo.length === 0) {
            return
        }
        const target = findNodeByLevel(evt.target)
        if (target == null) {
            return
        }
        const level = getParentNodeLevel(target)
        console.log(level, target)
        target.style.border = ''
        if (level.level1 != null) {
            if (selectedGoods.value.length > 0) {
                setGoodsGroup(selectedGoods.value as number[], level)
            } else {
                setGoodsGroup([goodsInfo.id], level)
            }
        }
    }

    function setGoodsGroup(goodsIds: number[], level: Level) {
        $fetch.post({
            url: '/goods/changegoodsgroup',
            params: {
                goods_ids: goodsIds,
                group_id: level.level1,
                secondary_group_id: level.level2 == null ? undefined : level.level2
            }
        }).then(() => {
            openMessage('success', '修改分组成功')
            const curEvent = getCurEvent()
            const limit = oPage.value * 20
            selectedGoods.value = []
            getGoodsByGroup(1, limit, currentLevel.level1, currentLevel.level2, keyword.value, true)
                .then(() => tbodyScroll(curEvent, ctx))
            props.onGoodsGroupChange()
        }).catch((e: any) => {
            openMessage('error', e.message)
        })
    }

    function findNodeByLevel(target): HTMLElement | null {
        for (let i: HTMLElement | null = target; i; i = i.parentElement) {
            if (i.classList.contains('level-2') || i.classList.contains('level-1')) {
                return i
            }
        }
        return null
    }

    function getParentNodeLevel(elm: HTMLElement): Level {
        if (elm.dataset.level1Id != null) {
            if (elm.dataset.level2Id != null) {
                return {
                    level1: +elm.dataset.level1Id,
                    level2: +elm.dataset.level2Id
                }
            } else {
                if (elm.nextElementSibling == null) {
                    return {
                        level1: +elm.dataset.level1Id,
                        level2: null
                    }
                } else if (elm.nextElementSibling.childElementCount < 2) {
                    return {
                        level1: +elm.dataset.level1Id,
                        level2: +((elm.nextElementSibling.firstElementChild as HTMLElement).dataset.level2Id as string)
                    }
                }
            }
        }
        return {
            level1: null,
            level2: null
        }
    }

    function getGoodsListByKeyword(keywordStr: string = '') {
        return $fetch.post({
            url: '/goods/searchgoods',
            params: {
                keyword: keywordStr
            }
        }).then(data => {
            console.log('商品搜索结果', data)
            goodsList.value = data
        }).catch(e => openMessage('error', e.message || '搜索失败'))
    }

    type ScrollLoadFunction = (page: number) => Promise<{
        pagination: {
            page: number,
            page_count: number
        }
    }>

    function bindListenerWithDom(dom: Element) {
        return bindListener({
            dom,
            loadFunction: (getGoodsByGroup as ScrollLoadFunction)
        })
    }

    return {
        goodsList,
        selectedGoods,
        getGoodsByGroup,
        getGoodsListByKeyword,
        onGoodsMove,
        onGoodsDragEnd,
        isGoodsListLoading,
        isSelectAll,
        isIndeterminate,
        isSearch,
        keyword,
        bindListenerWithDom,
        eventTarget,
        page: oPage,
        isHasMore,
        isLoading,
        getCurEvent,
        status: oStatus,
        findNodeByLevel
    }
}
